// extracted by mini-css-extract-plugin
export default {"root":"RealhubPremium__root--iUOM1"};